import React from "react";
import RecentModeSwitcher from "../../commonComponent/Switcher";
import { ReactComponent as OnDeviceIcon } from "../../../asset/file-icon.svg";

const EMPTY_RECENTS_MESSAGE =
  "You can save notes locally by adding a # to the title";
const HEADER_CLASS =
  "rounded-t-lg bg-surface-muted p-2 font-montserrat text-lg font-semibold";
const LIST_CLASS =
  "netpad-boxShadow-top mt-2 max-h-[40vh] list-disc overflow-y-auto rounded-b-lg p-2 pl-5 font-montserrat text-sm font-bold";
const PANEL_CLASS = "flex w-full flex-col bg-surface text-text";
const TITLE_BUTTON_CLASS =
  "block max-w-[70%] overflow-hidden overflow-ellipsis whitespace-nowrap text-left font-bold uppercase text-primary hover:underline";

const RecentTitleButton = ({ title, onTitleSelect }) => (
  <li>
    <button
      className={TITLE_BUTTON_CLASS}
      onClick={() => onTitleSelect(title)}
      type="button"
    >
      {title.startsWith("#") ? (
        <>
          <OnDeviceIcon className="mr-2 mb-1 inline-block h-5 w-5 fill-current text-yellow-500" />
          {title.substring(1)}
        </>
      ) : (
        title
      )}
    </button>
  </li>
);

const EmptyRecentTitles = () => (
  <p className="text-sm font-normal text-text-muted">
    {EMPTY_RECENTS_MESSAGE}
  </p>
);

const RecentTitlesList = ({ titles, onTitleSelect }) => {
  if (titles.length === 0) return <EmptyRecentTitles />;

  return titles.map((title) => (
    <RecentTitleButton
      key={title}
      onTitleSelect={onTitleSelect}
      title={title}
    />
  ));
};

const RecentTitlesPanel = ({
  isHeadingVisible = true,
  onModeChange,
  onTitleSelect,
  selectedMode,
  titles,
}) => (
  <section className={PANEL_CLASS}>
    {isHeadingVisible && <div className={HEADER_CLASS}>Recent Titles</div>}
    <div className="hidden md:block">
      <RecentModeSwitcher
        onSwitchHandler={onModeChange}
        selectedMode={selectedMode}
      />
    </div>
    <ul className={LIST_CLASS}>
      <RecentTitlesList titles={titles} onTitleSelect={onTitleSelect} />
    </ul>
  </section>
);

export default RecentTitlesPanel;
